import { useMemo } from 'react'
import { FORM_CREATE_COMPANY_LICENSE } from 'app-support/company/state/types'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { createLicenseForCompany } from 'app-support/company/state/actions'
import { useTranslation } from 'react-i18next'
import LicenseForm, { IFormValues } from 'app-support/company/components/Licenses/components/LicenseForm'
import { mapLicenseShopIDForAPI } from 'app-support/company/components/Licenses/ShopIDHelper'
import { apiFormat } from '@cbgms/base/utils/datetime'
import moment from 'moment'
import { useNotifier } from '@cbgms/base/notifier'

const NewLicense = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const { companyUUID } = useParams<{ companyUUID?: string }>()
  const redirectToURL = `/companies/edit/${companyUUID}#licenses`

  const handleSubmit = useMemo(
    () => async (values: IFormValues) => {
      if (!companyUUID) return

      // validFrom is optional, When provided, it should also specify a time.
      const validFrom = moment.utc(values.ValidFrom, apiFormat.yearMonthDay)
      // validTill is optional, The api will reject when validFrom > validTill.
      const validTill = moment.utc(values.ValidTill, apiFormat.yearMonthDay)

      const data = {
        ...values,
        CompanyUUID: companyUUID,
        ShopID: mapLicenseShopIDForAPI(values.ShopID),
        ValidFrom: validFrom.isValid() ? validFrom.format(apiFormat.iso) : null,
        ValidTill: validTill.isValid() ? validTill.format(apiFormat.iso) : null
      }
      await dispatch(createLicenseForCompany(data))

      return redirectToURL
    },
    [companyUUID]
  )

  const onSubmitSuccess = () => {
    notifier.success(t('companyLicense.created_success'))
  }

  return (
    <LicenseForm
      form={FORM_CREATE_COMPANY_LICENSE}
      handleSubmit={handleSubmit}
      onSubmitSuccess={onSubmitSuccess}
      redirectToURL={redirectToURL}
    />
  )
}

export default NewLicense
